import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { faqsPt, faqsEn, faqsDe } from '@/mocks/faqs';

export default function FAQPage() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqData = currentLang === 'pt' ? faqsPt : currentLang === 'en' ? faqsEn : faqsDe;

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <div className="max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-16">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6 md:mb-8">
          <a href="/" className="hover:text-primary-600 transition-colors">{t('breadcrumb_home')}</a>
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" />
          <span className="text-foreground-600 font-medium">FAQ</span>
        </nav>

        <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 tracking-tight mb-8 md:mb-10">
          CSSBuy Spreadsheet — FAQ
        </h1>

        <div className="space-y-3">
          {faqData.map((item, i) => (
            <div key={i} className="bg-background-100 border border-background-200/70 rounded-xl overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 md:px-6 md:py-5 text-left"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">{item.q}</span>
                <i className={`${openIndex === i ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} w-5 h-5 flex items-center justify-center text-foreground-400 flex-shrink-0`} />
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5 md:px-6 md:pb-6">
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 md:mt-12 bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-8 text-center">
          <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{t('final_cta_h2')}</h3>
          <p className="text-sm text-foreground-500 mb-5">{t('final_cta_desc')}</p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-block px-6 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            {t('final_cta_primary')}
          </a>
        </div>

        <div className="mt-8 text-center">
          <a href="/" className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors">
            <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center" />
            {t('breadcrumb_home')}
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
}